import React from 'react';
const EnterpriseSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-enterpiseSetting" });
EnterpriseSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-enterpiseSetting sirius-icon-enterpiseSetting-enhance" });
export default EnterpriseSvg;
